import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32.6665 0H0.666504V32H32.6665V0Z",
      class: "bg",
      fill: "#DAF6FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.5465 7.68024L15.5465 6.17357C15.8458 6.05805 16.1649 6.003 16.4856 6.01162C16.8063 6.02024 17.1221 6.09235 17.4147 6.22378C17.7073 6.35521 17.971 6.54335 18.1904 6.77733C18.4099 7.01131 18.5807 7.28647 18.6932 7.5869L23.0398 18.9869C23.2695 19.5916 23.2496 20.2628 22.9845 20.8528C22.7195 21.4429 22.231 21.9035 21.6265 22.1336L13.6265 25.1736C13.0218 25.4032 12.3506 25.3833 11.7606 25.1183C11.1705 24.8533 10.7099 24.3648 10.4798 23.7602L7.5465 16.0002L6.13316 12.3469C5.90354 11.7422 5.92343 11.0711 6.18845 10.481C6.45347 9.89095 6.94194 9.43027 7.5465 9.20024L11.5465 7.68024Z",
      class: "secondary",
      fill: "#80DDFC"
    }, null, -1),
    _createElementVNode("path", {
      d: "M21.4665 7.83991L17.3865 6.58657C17.0801 6.49176 16.758 6.4583 16.4386 6.48809C16.1193 6.51787 15.8089 6.61034 15.5253 6.76018C15.2418 6.91003 14.9905 7.11431 14.7859 7.36136C14.5814 7.6084 14.4275 7.89335 14.3332 8.19991L10.7598 19.8666C10.6652 20.1721 10.6319 20.4933 10.6619 20.8117C10.6918 21.1302 10.7844 21.4395 10.9344 21.7221C11.0843 22.0046 11.2886 22.2547 11.5355 22.4579C11.7824 22.6612 12.0671 22.8137 12.3732 22.9066L20.5332 25.4132C20.8396 25.5081 21.1617 25.5415 21.481 25.5117C21.8004 25.4819 22.1107 25.3895 22.3943 25.2396C22.6779 25.0898 22.9292 24.8855 23.1338 24.6385C23.3383 24.3914 23.4922 24.1065 23.5865 23.7999L25.9998 15.9999L27.1732 12.1999C27.3606 11.5828 27.2961 10.9167 26.9938 10.347C26.6915 9.77737 26.1759 9.35057 25.5598 9.15991L21.4665 7.83991Z",
      class: "primary",
      fill: "#00BBF9"
    }, null, -1)
  ])))
}
export default { render: render }